import * as types from './insights.types';

const initialState = {
  data: null,
  isLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_INSIGHTS_BY_JOB_ID_START:
      return {
        ...state,
        data: null,
        isLoading: true,
      };

    case types.GET_INSIGHTS_BY_JOB_ID_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };

    case types.GET_INSIGHTS_BY_JOB_ID_FAILS:
      return {
        ...state,
        isLoading: false,
      };

    default:
      return { ...state };
  }
};
